import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import "./index.css";
import { userManager } from "./services/authManager";
import { getSafeReturnPath } from "./services/socialLogin";

// Após o login: remove code/state da URL e restaura a rota de origem (returnTo
// enviado no state do signinRedirect). Aceita apenas paths relativos.
const onSigninCallback = (user) => {
  window.history.replaceState(
    {},
    document.title,
    getSafeReturnPath(user?.state?.returnTo) || window.location.pathname
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
